import { createEmptySimulationResult } from '@exodus/web3-utils';
import { getTransactionFee, simulateTransactions, } from './simulation/simulateTransactions.js';
import { decodeTxInstructions } from './simulation/transactionInstructions.js';
import { decodeRecipientAddresses } from './transactions.js';
export const createSimulateTransactions = ({ apiEndpoint = 'https://simulation.a.exodus.io/simulate', headers = {
    'X-Api-Version': '2023-06-05',
}, assetClientInterface, }) => async ({ transactions, asset, origin, overrideApiEndpoint, senderAddress, }) => {
    const simulationResult = createEmptySimulationResult({
        asset,
    });
    simulationResult.balanceChanges.willPayFee.push({
        balance: await getTransactionFee({
            asset,
            getFeeData: assetClientInterface.getFeeConfig,
            transactionsMessages: transactions,
            senderAddress,
        }),
    });
    await simulateTransactions({
        asset,
        transactions,
        apiEndpoint: overrideApiEndpoint || apiEndpoint,
        origin,
        simulationResult,
        headers,
        senderAddress,
    });
    try {
        simulationResult.advancedDetails = await decodeTxInstructions(transactions);
    }
    catch (error) {
        // TODO: accept a logger deps and log the error
    }
    // temporary until returned from the simulation endpoint
    simulationResult.recipientAddresses = transactions.map((tx) => decodeRecipientAddresses(tx));
    return simulationResult;
};
